export const sinceIntervals = [
    "MINUTES",
    "HOURS",
    "DAYS"
];
export const placementIntervals = [
    "HOUR",
    "DAY",
    "WEEK",
    "MONTH",
    "SINCE_INSTALL"
];
export const startsWithIntervalSince = (str)=>{
    return sinceIntervals.some((interval)=>str.startsWith(`${interval.toLowerCase()}Since_`));
};
export const startsWithPlacementInterval = (str)=>{
    return placementIntervals.some((interval)=>str.startsWith(`placementsIn${interval.charAt(0).toUpperCase() + interval.slice(1).toLowerCase()}_`) || str.startsWith(`placementsSinceInstall_`));
};
